module.exports = __webpack_public_path__ + "static/img/dashuju.3541f30b.png";